import { useQuery } from '@tanstack/react-query'
import {
	message,
	Input,
	Select,
	Table,
	Button,
	Modal,
	Checkbox,
	AutoComplete,
	Space,
	Tag,
	InputNumber,
	Spin,
} from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import { get } from 'lodash'
import moment from 'moment'
import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import CopyIcon from '@assets/icons/CopySvg'
import ViewIcon from '@assets/icons/viewSvg.jsx'
import Layout from '@components/Layout'
import ConfirmExitModal from '@components/Modal/ConfirmExitModal/index'
import CreteCustomerModal from '@components/Modal/createCustomerModal'
import ErrorModal from '@components/Modal/ErrorModal'
import SuccessModal from '@components/Modal/SuccessModal'
import ViewDepartmentsBalanceModal from '@components/Modal/viewDepartmentsBalanceModal'
import WarningModal from '@components/Modal/WarningModal/index'
import { http } from '@services/http'
import { submitSalesOrder } from '@slice/salesSlice'
import { calculateKvmWithSpaces , calculateKvm } from '@utils/calculateKvm'
import {
	calculateTotalWithKoef,
	calculateLineTotal,
	calculateMetrTotalWithKoef,
} from '@utils/calculations'
import { debouncedSet } from '@utils/debounce'
import { catchError } from '@utils/errrorHandling'
import {
	fetchClientsSelect,
	fetchItemsSelect,
	fetchDepartments,
	fetchSalesPerson,
	fetchWarehouse,
	fetchPackageServicesNoPagination,
} from '@utils/fetchData'
import { generateImage } from '@utils/generateShapeImage'
import {
	formatNumberWithSpaces,
	numberWithSpacesIntl,
	removeSpaces,
} from '@utils/numberWithSpaces'
import {
	circleServiceQuantity,
	perimeterQuantity,
} from '@utils/salesOrderCalculations'

import ServicesModal from '../ServicesModal'

const calculateShtPrices = (selectedServices, priceKey = 'price') => {
	return selectedServices.reduce((acc, service) => {
		if (
			service.ugpName === 'шт' &&
			!service.isKalitParametr &&
			service.u_Modal !== 'Templete_Services' &&
			service.u_Modal !== 'ort' &&
			service.u_Modal !== 'Xarajatlar'
		) {
			return (
				acc +
				service[priceKey] *
					service.u_FigureQuantity *
					service.u_PlannedQuantity
			)
		} else if (
			service.ugpName === 'шт' &&
			service.isKalitParametr &&
			service.u_Modal !== 'ort' &&
			service.u_Modal !== 'Xarajatlar'
		) {
			return (
				acc +
				service[priceKey] *
					(+service.u_FigureQuantity * +service.itemQuantity)
			)
		}
		return acc
	}, 0)
}

const calculateMetrPriceServices = (selectedServices, priceKey = 'price') => {
	return (
		selectedServices?.reduce((acc, service) => {
			if (
				service.ugpName === 'м' &&
				!service.isParametr &&
				service.u_Modal !== 'Circle_Services' &&
				service.u_Modal !== 'Rhombic_Figures' &&
				service.u_Modal !== 'Templete_Services' &&
				service.u_Modal !== 'ort' &&
				service.u_Modal !== 'Telefon' &&
				service.u_Modal !== 'Xarajatlar'
			) {
				return (
					acc +
					+service[priceKey] *
						((((+service.width + +service.height) * 2) / 1000) *
							+service.u_PlannedQuantity)
				)
			} else if (
				service.ugpName === 'м' &&
				service.u_Modal === 'Circle_Services' &&
				service.u_Modal !== 'Templete_Services' &&
				service.u_Modal !== 'ort' &&
				service.u_Modal !== 'Telefon' &&
				service.u_Modal !== 'Xarajatlar'
			) {
				return (
					acc +
					service[priceKey] *
					circleServiceQuantity(service.width, service.itemQuantity)
				)
			} else if (
				service.u_Modal === 'Templete_Services' ||
				service.u_Modal === 'Telefon'
			) {
				return (
					acc +
					service[priceKey] *
						+service.u_FigureQuantity *
						service.u_PlannedQuantity
				)
			}
			return acc
		}, 0) || 0
	)
}

const calculateMetrPricesParametr = (selectedServices, priceKey = 'price') => {
	return (
		selectedServices?.reduce((acc, service) => {
			if (
				(service.ugpName === 'м' &&
					service.isParametr &&
					service.u_Modal !== 'ort' &&
					service.u_Modal !== 'Xarajatlar' &&
					service.u_Modal !== 'Templete_Services') ||
				service.u_Modal === 'Rhombic_Figures'
			) {
				return (
					acc +
					service.itemQuantity *
						(service[priceKey] *
							(service.u_FigureQuantity * service.quantity))
				)
			}
			return acc
		}, 0) || 0
	)
}

const calculateKvmPrices = (selectedServices, priceKey = 'price') => {
	return selectedServices?.reduce((acc, service) => {
		if (
			service.ugpName !== 'шт' &&
			service.ugpName !== 'м' &&
			service.u_Modal !== 'Templete_Services' &&
			service.u_Modal !== 'ort' &&
			service.u_Modal !== 'Xarajatlar'
		) {
			return (
				acc +
				service[priceKey] *
					(calculateKvm(service?.width, service?.height) *
						service?.u_PlannedQuantity)
			)
		}
		return acc
	}, 0)
}
const calculateOtgruzkaServices = (selectedServices) => {
	return selectedServices?.reduce((acc, service) => {
		if (service.u_Modal === 'ort') {
			return acc + service.price * service?.u_PlannedQuantity
		}
		return acc
	}, 0)
}

// This is the hardest screen in our project and I know that i have to optimize my codes in this page when i will be free i will do it

const EditSalesOrder = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const successRef = useRef()
	const errorRef = useRef()
	const warningRef = useRef()

	const docEntry = window.location.pathname.split('/').pop()

	const { roleNames,} = useSelector(
		(state) => state.main,
	)

	const isAdmin = roleNames.includes('admin')


	const isDisabled = true

	const [clientCode, setClientCode] = useState('')
	const [clientName, setClientName] = useState('')
	const [searchClientName, setSearchClientName] = useState('')
	const [searchItemName, setSearchItemName] = useState('')
	const [date, setDate] = useState('')
	const [currency, setCurrency] = useState('UZS')
	const [comments, setComments] = useState('')
	const [sendFile, setSendFile] = useState(false)
	const [imageList, setImageList] = useState([
		{ file: null, path: '', imgLoading: false },
	])
	const [whs, setWhs] = useState('')
	const [isModalVisible, setIsModalVisible] = useState(false)
	const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false)
	const [isViewBpBalanceModalVisible, setIsViewBpBalanceModalVisible] =
		useState(false)
	const [isConfirmServiceModalVisible, setIsConfirmServiceModalVisible] =
		useState(false)
	const [activeTab, setActiveTab] = useState('tab1')
	const [btnLoading, setIsBtnLoading] = useState(false)
	const [isDiscountBigger, setIsDiscountBigger] = useState(false)
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [selectedServices, setSelectedServices] = useState([])
	const [currentRecord, setCurrentRecord] = useState(null)
	const [departmentAdmin, setDepartmentAdmin] = useState('')
	const [slpAdmin, setSlpAdmin] = useState('')
	const [dateSale, setDateSale] = useState('')
	const [bpDebt, setBpDebt] = useState('')
	const [docTotalWithDiscount, setDocTotalWithDiscount] = useState(0)
	const [inputDocTotal, setInputDocTotal] = useState(0)
	const [inputValues, setInputValues] = useState({})
	const [inputParametrQuantity, setInputParametrQuantity] = useState({})
	const [tableData, setTableData] = useState([
		{
			key: '1',
			itemCode: null,
			itemName: null,
			width: '',
			height: '',
			quantity: '',
			ugpName: '',
			price: '',
			currency: currency,
			lineTotal: '',
			lineNum: 0,
			u_Timer: '',
			disabled: false,
			koefitsent: 1,
			selectedServices: [],
			amountInWhs: 0,
			itemType: 'Item',
		},
	])
	const [inputDateCount, setInputDateCount] = useState('')

	const [selectedRowIndex, setSelectedRowIndex] = useState(null)

	const [isServicesModalVisible, setIsServicesModalVisible] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(null)

	const docTotal = tableData?.reduce((acc, row) => {
		const koef = row.koefitsent || 1

		// const selectedPrices = row?.selectedServices?.reduce((acc, service) => {
		// 	if (service.ugpName !== 'шт' && service.ugpName !== 'м') {
		// 		return (
		// 			acc +
		// 			service.price *
		// 				(calculateKvm(row?.width, row?.height) * row?.quantity)
		// 		)
		// 	}
		// 	return acc
		// }, 0)

		const selectedPrices = calculateKvmPrices(row?.selectedServices)

		const shtPrices = calculateShtPrices(row?.selectedServices)

		const metrPricesServices = calculateMetrPriceServices(
			row?.selectedServices,
		)
		const metrPricesParametr = calculateMetrPricesParametr(
			row?.selectedServices,
		)

		const totalWithKoef = calculateTotalWithKoef(
			row.width,
			row.height,
			row.quantity,
			1,
		)

		return (
			acc +
			(calculateLineTotal(row.price, 0, totalWithKoef || 0) +
				(shtPrices || 0) +
				(selectedPrices || 0) +
				(metrPricesServices || 0) +
				(metrPricesParametr || 0))
		)
	}, 0)

	const sanitizeDocTotalValue = (rawValue) => {
		const sanitizedValue = rawValue
			.replace(/\s+/g, '')
			.replace(',', '.')

		return parseFloat(sanitizedValue) || 0
	}

	const handleDocTotalChange = (e) => {
		const value = sanitizeDocTotalValue(e.target.value)
		const originalDocTotal = Number(docTotal) || 0

		// if (!isAdmin && value < originalDocTotal) {
		// 	setInputDocTotal(originalDocTotal)
		// 	setIsDiscountBigger(false)
		// 	return
		// }

		setInputDocTotal(value)
		if(!isAdmin) {
			setIsDiscountBigger(value < originalDocTotal)
		}
	}

	const handleDocTotalBlur = (e) => {
		const value = sanitizeDocTotalValue(e.target.value)
		const originalDocTotal = Number(docTotal) || 0

		if (!isAdmin && value < originalDocTotal) {
			setInputDocTotal(originalDocTotal)
			setIsDiscountBigger(true)
			return
		}

		setInputDocTotal(value)
		if(!isAdmin) {
			setIsDiscountBigger(value < originalDocTotal)
		}
	}

	const otgruzkaServicesTotal = tableData?.reduce((acc, row) => {
		const selectedPrices = calculateOtgruzkaServices(row?.selectedServices)

		return acc + (selectedPrices || 0)
	}, 0)

	const totalKvm = new Intl.NumberFormat().format(
		tableData.reduce(
			(acc, row) =>
				acc +
				(parseFloat(
					row.quantity * calculateKvm(row.width, row.height),
				) * (row.koefitsent || 1) || 0),
			0,
		),
	)

	const biggestLineNum = Math.max(
		...tableData.flatMap((row) => [
			row.lineNum,
			...(row.selectedServices?.map((service) => service.lineNum) || []),
		]),
		0,
	)

	const totalPerimetr = new Intl.NumberFormat().format(
		tableData.reduce((acc, row) => acc + row.totalPerimetr || 0, 0),
	)

	const elektrTotal = tableData?.reduce(
		(acc, row) => {
			console.log('selectedServices', row.selectedServices)

			const koef = row.koefitsent || 1

			const selectedPrices = row?.selectedServices?.reduce(
				(acc, service) => {
					if (
						service.ugpName !== 'шт' &&
						service.ugpName !== 'м' &&
						service.u_Modal !== 'Templete_Services' &&
						service.u_Modal !== 'ort' &&
						service.u_Modal !== 'Xarajatlar'
					) {
						return (
							acc +
							+service.u_ElectricityCost *
								+(
									calculateKvm(row?.width, row?.height) *
									row?.u_PlannedQuantity
								)
						)
					}
					return acc
				},
				0,
			)

			const shtPrices = calculateShtPrices(
				row?.selectedServices,
				'u_ElectricityCost',
			)

			const metrPricesServices = calculateMetrPriceServices(
				row?.selectedServices,
				'u_ElectricityCost',
			)

			const metrPricesParametr = calculateMetrPricesParametr(
				row?.selectedServices,
				'u_ElectricityCost',
			)

			const lineTotal =
				(shtPrices || 0) +
				(selectedPrices || 0) +
				(metrPricesServices || 0) +
				(metrPricesParametr || 0)

			console.log(
				'lineTotal',
				lineTotal,
				shtPrices || 0,
				selectedPrices || 0,
				metrPricesServices || 0,
				metrPricesParametr || 0,
			)

			return {
				total: acc.total + lineTotal,
				itemCode: 'Elektr_xarajat',
			}
		},
		{ total: 0, itemCode: '' },
	)

	const stanokTotal = tableData?.reduce(
		(acc, record) => {
			const metrPricesService =
				calculateMetrPriceServices(
					record.selectedServices,
					'u_MachineCost',
				) || 0

			const metrPricesParametrV1 =
				calculateMetrPricesParametr(
					record.selectedServices,
					'u_MachineCost',
				) || 0

			const shtPrices =
				calculateShtPrices(record.selectedServices, 'u_MachineCost') ||
				0

			const m2Prices =
				record.selectedServices.reduce((acc, service) => {
					if (
						service.ugpName !== 'шт' &&
						service.ugpName !== 'м' &&
						service.u_Modal !== 'ort'
					) {
						return acc + service.u_MachineCost
					}
					return acc
				}, 0) *
				(+record.quantity *
					((+record.width * +record.height) / 1000000) *
					1)

			const lineTotal =
				m2Prices + metrPricesService + metrPricesParametrV1 + shtPrices

			return {
				total: acc.total + lineTotal,
				itemCode: 'stanokk_xarajat',
			}
		},
		{ total: 0, itemCode: '' },
	)

	console.log('stanokTotal', stanokTotal)
	console.log('elektrTotal', elektrTotal)

	// const fetchItemsGeometricShapes = async () => {
	// 	try {
	// 		let url = `api/items/get-items?category=Геометрические фигуры&pageSize=100&pageToken=0`
	// 		const { data } = await http.get(url)
	// 		const formattedData = data.data
	// 			.map((item) => ({
	// 				...item,
	// 				image: generateImage(item.itemCode),
	// 			}))
	// 			.sort((a, b) => a.itemCode.localeCompare(b.itemCode))
	// 		return formattedData
	// 	} catch (error) {
	// 		console.log(error)
	// 	}
	// }

	// const fetchItemsImages = async () => {
	// 	try {
	// 		let url = `api/items/get-items?category=Рисунок&pageSize=100&pageToken=0`
	// 		const { data } = await http.get(url)
	// 		const formattedData = data.data.map((item) => ({
	// 			...item,
	// 			image: generateImage(item.itemCode),
	// 		}))
	// 		return formattedData
	// 	} catch (error) {
	// 		console.log(error)
	// 	}
	// }

	// const fetchItemsServices = async ({ queryKey }) => {
	// 	const [_, modalService] = queryKey
	// 	try {
	// 		let url = `api/items/get-items?categories=101&modalService=${modalService}&pageSize=500&pageToken=0`
	// 		const { data } = await http.get(url)
	// 		const formattedData = data.data
	// 		return formattedData
	// 	} catch (error) {
	// 		console.log(error)
	// 	}
	// }

	const fetchExpensesItems = async ({ queryKey }) => {
		const [_, uModal] = queryKey
		try {
			const url = `api/items/get-items?modalService=${uModal}&pageToken=0&pageSize=100`
			const { data } = await http.get(url)

			const formattedData = data.data
			return formattedData
		} catch (error) {
			console.log(error)
		}
	}

	const fetchBpBalance = async ({ queryKey }) => {
		const [, clientCode] = queryKey
		if (clientCode) {
			try {
				const url = `api/businesspartners/get-business-partners-balance?cardCode=${clientCode}`
				const { data } = await http.get(url)
				setBpDebt(
					data[0]?.departments?.reduce(
						(acc, item) => acc + item.balance,
						0,
					),
				) || 0
				return data
			} catch (error) {
				console.log(error)
			}
		}
	}


	const fetchOneSalesOrder = async ({ queryKey }) => {
		const [_, docEntry] = queryKey
		try {
			const url = `api/items/sales-order-items/${docEntry}`
			const { data } = await http.get(url)
			return data
		} catch (error) {
			console.log(error)
		}
	}

	const { data: salesOrderData = [] } = useQuery({
		queryKey: ['oneSalesOrder', docEntry],
		queryFn: fetchOneSalesOrder,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: bpBalanceData = [] } = useQuery({
		queryKey: ['bpBalance', clientCode],
		queryFn: fetchBpBalance,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const {
		data: clientsData = [],
		isLoading: loadingClient,
		refetch,
	} = useQuery({
		queryKey: [
			'clients',
			searchClientName,
			'20',
			'api/businesspartners/mijozlar',
		],
		queryFn: fetchClientsSelect,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: itemsData = [], isLoading: itemsLoading } = useQuery({
		queryKey: ['items', searchItemName, 'Окно', 'api/items/get-items'],
		queryFn: fetchItemsSelect,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 60000,
	})

	const { data: warehouseData = [], isLoading: whsLoading } = useQuery({
		queryKey: ['warehouses'],
		queryFn: fetchWarehouse,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: departmentData = [], isLoading: departmentLoading } =
		useQuery({
			queryKey: ['departments'],
			queryFn: fetchDepartments,
			keepPreviousData: true,
			refetchOnWindowFocus: false,
		})

	const { data: slpData = [], isLoading: slpLoading } = useQuery({
		queryKey: ['salesPerson'],
		queryFn: fetchSalesPerson,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	useEffect(() => {
		if (salesOrderData) {
			const mappedData = salesOrderData?.documentLines
				?.filter((item) => {
					return item.u_Modal !== 'Xarajatlar'
				})
				?.map((item) => {
					return {
						...item,
						width: item.u_Width || 0,
						height: item.u_Height || 0,
						itemName: item.itemDescription,
						quantity: item.u_PlannedQuantity, //
						selectedServices: item.services.map((service) => ({
							...service,
							width: item.u_Width || 0,
							height: item.u_Height || 0,
							isService:
								service.u_ItemGroup == 'Service' ? true : false,
							isParametr:
								service.u_ItemGroup == 'Shape' ? true : false,
							isChizma:
								service.u_ItemGroup == 'Chizma' ? true : false,
							isKalitParametr:
								service.u_Modal == 'Key_Figures' ? true : false,

							isShablonService:
								service.u_Modal == 'Templete_Services'
									? true
									: false,

							isShablonParametr:
								service.u_Modal == 'Templete_Figures'
									? true
									: false,

							itemQuantity: item.u_PlannedQuantity,

							quantity:
								service.u_ItemGroup == 'Shape'
									? service.u_ShapeSides
											?.split(';')
											.reduce(
												(acc, val) => acc + +val,
												0,
											) / 1000 //  u_ItemGroup Shakl bo'lsa yozgan valuelarini summasini quantity qlb qoyish kerak edi shunda pasdigi logikalaram togir ishlidi
									: service.quantity,
						})),
						key: item.lineNum,

						services: item.services.map((service) => ({
							...service,
							width: item.u_Width || 0,
							height: item.u_Height || 0,
							isService:
								service.u_ItemGroup == 'Service' ? true : false,
							isParametr:
								service.u_ItemGroup == 'Shape' ? true : false,
							isChizma:
								service.u_ItemGroup == 'Chizma' ? true : false,
							isKalitParametr:
								service.u_Modal == 'Key_Figures' ? true : false,

							isShablonService:
								service.u_Modal == 'Templete_Services'
									? true
									: false,

							isShablonParametr:
								service.u_Modal == 'Templete_Figures'
									? true
									: false,

							itemQuantity: item.u_PlannedQuantity,
							quantity:
								service.u_ItemGroup == 'Shape'
									? service.quantity / 100
									: service.quantity,
						})),

						koefitsent: item.u_Coefficient || 1,
						amountInWhs: item?.onHand,
					}
				})
			setTableData(mappedData || [])
			setComments(salesOrderData.comments)
			setWhs(
				salesOrderData?.documentLines &&
					salesOrderData?.documentLines[0]?.warehouseCode,
			)
			setDepartmentAdmin(salesOrderData?.u_Department)
			setSlpAdmin(salesOrderData?.slpCode)
			setDateSale(salesOrderData?.docDate)
			setClientCode(salesOrderData?.cardCode)
			setClientName(salesOrderData?.cardName)
			setInputDocTotal(salesOrderData?.docTotal)
			setDate(salesOrderData?.docDueDate)
			setInputDateCount(salesOrderData?.u_DueDays)
		}
	}, [salesOrderData])

	const columns = [
		{
			title: t('item'),
			dataIndex: 'itemCode',
			key: 'itemCode',
			fixed: 'left',
			width: 250,
			render: (_, record, index) => (
				<AutoComplete
					loading={itemsLoading}
					options={itemsData?.map((item) => ({
						value: item.itemCode,
						label: item.itemName,
						data: {
							ugpName: item.ugpName,
							price: item.price,
							koefitsent: item.u_DefaultCoefficient || 1,
							u_Number: item.u_Number,
							u_Timer: item.u_Timer,
						},
					}))}
					className="w-full "
					value={record.itemName}
					onSelect={async (value, label) => {
						const url = `api/items/inventory-items?itemCode=${value}`
						const { data } = await http.get(url)
						const amountInWhs = data.data[0]?.inventoryItemWhs
							.filter((item) => item.whsCode === whs)
							.map((item) => item.onHand)

						const updatedData = tableData.map((row) =>
							row.key === record.key
								? {
										...row,
										itemCode: label.value,
										itemName: label.label || '',
										quantity: '',
										ugpName: label?.data?.ugpName || '',
										price: label?.data?.price || '',
										lineTotal: '',
										disabled: true,
										koefitsent:
											label?.data?.koefitsent || 1,
										u_Number: label?.data?.u_Number || '',
										u_Timer: label?.data?.u_Timer || '',
										amountInWhs,
									}
								: row,
						)
						handleItemNameChange('')
						setTableData(updatedData)
					}}
					disabled={
						record.disabled || record.amountInWhs >= 0 || isDisabled
					}
					onChange={(val) => {
						const value = val || ''
						handleItemNameChange(value)
						const updatedData = tableData.map((row) =>
							row.key === record.key
								? {
										...row,
										itemName: value || '',
									}
								: row,
						)
						setTableData(updatedData)
					}}
					showSearch
				/>
			),
		},
		{
			title: `${t('width')} (${t('mm')})`,
			dataIndex: 'width',
			key: 'width',
			width: 150,
			render: (_, record) => (
				<Input
					value={formatNumberWithSpaces(record.width)}
					className={'w-full'}
					disabled={isDisabled}
					onChange={(e) => {
						const updatedData = tableData.map((row) => {
							if (row.key === record.key) {
								const rawInput = e.target.value

								// Sanitize the raw input (remove spaces and non-numeric characters)
								const sanitizedWidth = rawInput
									.replace(/[^0-9.,]/g, '')
									.replace(/\s+/g, '')

								// Parse as number for calculations
								const width =
									parseFloat(
										sanitizedWidth.replace(',', '.'),
									) || 0

								return {
									...row,
									width,
								}
							}
							return row
						})
						setTableData(updatedData)
					}}
				/>
			),
		},
		{
			title: `${t('height')} (${t('mm')})`,
			dataIndex: 'height',
			key: 'height',
			width: 150,
			render: (_, record) => (
				<Input
					value={formatNumberWithSpaces(record.height)}
					className={'w-full'}
					disabled={isDisabled}
					onChange={(e) => {
						const updatedData = tableData.map((row) => {
							if (row.key === record.key) {
								const rawInput = e.target.value

								const height =
									parseFloat(
										removeSpaces(rawInput).replace(
											',',
											'.',
										),
									) || 0

								return {
									...row,
									height,
								}
							}
							return row
						})

						setTableData(updatedData)
					}}
				/>
			),
		},
		{
			title: t('quantity'),
			dataIndex: 'quantity',
			key: 'quantity',
			width: 150,
			render: (_, record) => (
				<Input
					value={formatNumberWithSpaces(record.quantity)}
					className="w-full"
					disabled={isDisabled}
					onChange={(e) => {
						const rawInput = e.target.value

						const updatedData = tableData.map((row) => {
							if (row.key === record.key) {
								const quantity =
									parseFloat(
										removeSpaces(rawInput).replace(
											',',
											'.',
										),
									) || 0
								return {
									...row,
									quantity,
								}
							}
							return row
						})

						setTableData(updatedData)
					}}
				/>
			),
		},
		{
			title: t('kv.m'),
			dataIndex: 'ugpName',
			key: 'ugpName',
			width: 150,
			render: (_, record) => {
				const koef = 1
				const totalWithKoef =
					calculateKvm(record.width, record.height) *
					parseFloat(record.quantity || 0) *
					koef

				// console.log(
				// 	'record = ',
				// 	record.width,
				// 	record.height,
				// 	calculateKvm(record.width, record.height),
				// )

				return (
					<span className="w-full">
						{numberWithSpacesIntl(totalWithKoef)}
					</span>
				)
			},
		},
		{
			title: t('pricePerKv'),
			dataIndex: 'price',
			key: 'price',
			width: 170,
			render: (_, record) => (
				<span className="w-full">
					{numberWithSpacesIntl(record.price || 0)}
				</span>
			),
		},
		// Uslugi modalga kirish bu joyda agar ugpName sht bolsa uni narxga qoshmaslik aks xolda uni userga usligi yozuvi orniga korastish kerak
		{
			title: t('services'),
			key: 'services',
			width: 120,
			render: (_, record, index) => {
				const metrPricesService =
					calculateMetrPriceServices(record.selectedServices) || 0

				const metrPricesParametrV1 =
					calculateMetrPricesParametr(record.selectedServices) || 0

				const shtPrices =
					calculateShtPrices(record.selectedServices) || 0

				const m2Prices =
					record.selectedServices.reduce((acc, service) => {
						if (
							service.ugpName !== 'шт' &&
							service.ugpName !== 'м' &&
							service.u_Modal !== 'ort'
						) {
							return acc + service.price
						}
						return acc
					}, 0) *
					(+record.quantity *
						((+record.width * +record.height) / 1000000) *
						1)

				const servicesTotal =
					m2Prices +
					metrPricesService +
					metrPricesParametrV1 +
					shtPrices

				console.log(
					'servicesTotal',
					servicesTotal,
					metrPricesService,
					metrPricesParametrV1,
				)

				return (
					<div className="flexw- full items-center justify-center">
						<Button
							type="primary"
							onClick={() => {
								setIsModalOpen(true)
								setCurrentRecord(record)
								setSelectedServices(
									record.selectedServices || [],
								)
								setSelectedRowIndex(index)
							}}
						>
							{record.width > 0 ||
							record.height > 0 ||
							record.quantity > 0
								? numberWithSpacesIntl(
										servicesTotal > 0 ? servicesTotal : 0,
									)
								: t('services')}
						</Button>
					</div>
				)
			},
		},
		{
			title: t('totalMiqdor'),
			dataIndex: 'lineTotal',
			key: 'lineTotal',
			width: 170,
			render: (_, record, index) => {
				// console.log('record = ', index, record)

				const selectedPrices = calculateKvmPrices(
					record?.selectedServices,
				)

				const shtPrices = calculateShtPrices(record.selectedServices)
				const koef = 1
				const totalWithKoef = calculateTotalWithKoef(
					record.width,
					record.height,
					record.quantity,
					koef,
				)

				const metrPricesServices = calculateMetrPriceServices(
					record?.selectedServices,
				)

				const metrPricesParametr = calculateMetrPricesParametr(
					record?.selectedServices,
				)
				const lineTotal =
					calculateLineTotal(record.price, 0, totalWithKoef) +
					shtPrices +
					metrPricesServices +
					metrPricesParametr +
					selectedPrices

				console.log(
					'lineTotal',
					lineTotal,
					selectedPrices,
					shtPrices,
					metrPricesServices,
					metrPricesParametr,
				)

				return <span>{numberWithSpacesIntl(lineTotal || 0)}</span>
			},
		},
		// {
		// 	title: t('actions'),
		// 	key: 'actions',
		// 	width: 100,

		// 	render: (_, record) => (
		// 		<div className="flex gap-2 items-center justify-center">
		// 			<Button type="primary" onClick={addRow}>
		// 				+
		// 			</Button>
		// 			<Button type="primary" onClick={() => copyRow(record)}>
		// 				<CopyIcon />
		// 			</Button>
		// 			<Button
		// 				danger
		// 				type={'primary'}
		// 				onClick={() => removeRow(record.key)}
		// 				disabled={tableData.length === 1}
		// 			>
		// 				-
		// 			</Button>
		// 		</div>
		// 	),
		// }, // Hozircha qator qoshib, ozgartirolmas ekan
	]

	const columnsKoefitsent = [
		{
			title: t('item'),
			dataIndex: 'itemName',
			key: 'itemName',
			width: 200,
		},
		{
			title: t('kv.m'),
			dataIndex: 'lineTotalWithKoef',
			key: 'lineTotalWithKoef',
			render: (totalWithKoef) => (
				<span className="w-full">
					{numberWithSpacesIntl(totalWithKoef)}
				</span>
			),
		},
		{
			title: t('amountInWhs'),
			dataIndex: 'amountInWhs',
			key: 'amountInWhs',
			render: (text) => (
				<span className="w-full">
					{text ? new Intl.NumberFormat().format(text) : text}
				</span>
			),
		},
		{
			title: t('actions'),
			dataIndex: 'amountInWhs',
			key: 'amountInWhs',
			render: (text) => (
				<span className="w-full">
					{+text <= 0 && <Tag color="red">{t('itemIsNotInWhs')}</Tag>}
				</span>
			),
		},
		{
			title: t('totalMiqdor'),
			dataIndex: 'lineTotal',
			key: 'lineTotal',
			render: (_, record) => {
				const selectedPrices = calculateKvmPrices(
					record?.selectedServices,
				)

				const shtPrices = calculateShtPrices(record.selectedServices)

				const koef = record.koefitsent || 1
				const totalWithKoef = record.lineTotalWithKoef // Use the precomputed summarized value

				const metrPricesServices = calculateMetrPriceServices(
					record?.selectedServices,
				)

				const metrPricesParametr = calculateMetrPricesParametr(
					record?.selectedServices,
				)

				//	Bunda usluga,item,Figuraniki hisoblidi koefitsent bn
				const lineTotal =
					calculateLineTotal(
						record.price,
						0, //Endi Uslugalarni Narxini koefitsent bn hisoblanmidi
						totalWithKoef,
					) +
					shtPrices +
					metrPricesServices +
					metrPricesParametr +
					selectedPrices

				//	Bunda faqat itemmikini hisoblidi koefitsent bn
				// const lineTotal =
				// 	calculateLineTotal(
				// 		record.price,
				// 		0, //Endi Uslugalarni Narxini koefitsent bn hisoblanmidi
				// 		totalWithKoef,
				// 	) + selectedPrices

				// Update the summarized record with the calculated lineTotal (optional)
				record.lineTotal = lineTotal

				return (
					<span className="w-full">
						{numberWithSpacesIntl(lineTotal || 0)}
					</span>
				)
			},
		},
		{
			title: t('Koefitsent'),
			dataIndex: 'koefitsent',
			key: 'koefitsent',
			render: (_, record) => {
				return (
					<Input
						type="number"
						onWheel={(e) => e.target.blur()}
						min={-1}
						suffix="%"
						controls={false}
						disabled={isDisabled}
						value={record.koefitsent}
						onChange={(e) =>
							handleKoefitsentChange(
								e.target.value,
								record.itemName,
							)
						}
						className="w-full"
					/>
				)
			},
		},
	]

	const onSubmit = async () => {
		// console.log('tableData = ', tableData)

		const originalDocTotal = Number(docTotal) || 0

		// if (!clientCode) return message.error('Клиент не выбран')
		if (!inputDocTotal) return message.error('Общая сумма не указана')
		if (!isAdmin && inputDocTotal < originalDocTotal) {
			setInputDocTotal(originalDocTotal)
			setIsDiscountBigger(false)
			return message.error('Общая сумма меньше суммы товаров')
		}
		if (!date) return message.error('Дата срока не выбрана')
		// if (!currency) return message.error('Валюта не выбрана')
		if (!departmentAdmin) return message.error('Отдел не выбран')
		// if (!slpAdmin) return message.error('Менеджер продаж не выбран')
		if (!whs) return message.error('Склад не выбран')
		// if (!get(getMe, 'employeeId', ''))
		// return message.error('EmployeeId не задан')
		if (tableData.length === 0) return message.error('Таблица пустая')
		if (tableData?.some((row) => !row.itemCode))
			return message.error('Товар не выбран')

		const photoId = (imageList || [])
			.map((image) => image.path)
			.filter(Boolean)
			.join(',')

		setIsBtnLoading(true)

		const prevLocation = sessionStorage.getItem('prevLocation')

		console.log('tableData = ', tableData)
		const baseEntry = salesOrderData.docEntry // 178 — original Sales Order DocEntry

		let currentLineNum = 0
		const getNextLineNum = () => currentLineNum++

		const totalItemsQuantity = tableData.reduce((total, row) => {
			return (
				total +
				Number(row.quantity) * +calculateKvm(row.width, row.height)
			)
		}, 0)

		try {
			const data = {
				docDueDate: date,
				// docTotal: inputDocTotal,
				docTotal: inputDocTotal - salesOrderData?.docTotal,
				comments: comments,
				docCurrency: currency,
				department: departmentAdmin,
				u_DueDays: inputDateCount,
				totalDiscount: otgruzkaServicesTotal,

				// docDueDate: 'string',
				// docTotal: 0,
				// docCurrency: 'string',
				// comments: 'string',
				// department: departmentAdmin,
				// u_ChertejId: 'string',
				// documentLines: [
				// 	// 1. Original lines from the existing Sales Order (marked as "Was" for correction invoice)
				// 	...(Array.isArray(salesOrderData?.documentLines)
				// 		? salesOrderData.documentLines.flatMap(
				// 				(originalLine) => {
				// 					// Main item line (the product itself)
				// 					const mainLine = {
				// 						lineNum: originalLine.lineNum,
				// 						itemCode: originalLine.itemCode,
				// 						quantity: Number(originalLine.quantity),
				// 						unitPrice: Number(originalLine.price),
				// 						currency: originalLine.currency,
				// 						warehouseCode:
				// 							originalLine.warehouseCode,
				// 						correctionInvoiceItem: 'ciis_Was', // This marks it as the old line
				// 						itemDescription:
				// 							originalLine.itemDescription,
				// 						// Copy all other needed fields
				// 						u_uslugaID:
				// 							Number(originalLine.u_uslugaID) ||
				// 							0,
				// 						u_Produkt: originalLine.u_Produkt,
				// 						u_Kvmetr:
				// 							originalLine.u_Kvmetr ||
				// 							calculateKvm(
				// 								originalLine.u_Width,
				// 								originalLine.u_Height,
				// 							),
				// 						u_Width: originalLine.u_Width,
				// 						u_Height: originalLine.u_Height,
				// 						u_Coefficient:
				// 							originalLine.u_Coefficient,
				// 						u_PlannedQuantity:
				// 							originalLine.u_PlannedQuantity,
				// 						u_Number: originalLine.u_Number || '',
				// 						u_ItemGroup:
				// 							originalLine.u_ItemGroup || 'Item',
				// 						u_FigureQuantity: Number(
				// 							originalLine.u_FigureQuantity || 0,
				// 						),
				// 						u_ShapeSides:
				// 							originalLine.u_ShapeSides || '',
				// 						u_SizeType:
				// 							originalLine.u_SizeType || '',
				// 						u_SharepeningType:
				// 							originalLine.u_SharepeningType ||
				// 							'',
				// 						u_ConnectedShape:
				// 							originalLine.u_ConnectedShape || '',
				// 						u_Modal: originalLine.u_Modal || '',
				// 						discountPercent: 0,
				// 					}

				// 					// Service lines attached to this item (like REZKA, delivery, etc.)
				// 					const serviceLines = (
				// 						originalLine.services || []
				// 					).map((service) => ({
				// 						lineNum: service.lineNum,
				// 						itemCode: service.itemCode,
				// 						quantity: Number(service.quantity),
				// 						unitPrice:
				// 							service.u_Modal === 'ort'
				// 								? 0
				// 								: Number(service.price), // Ortish usually has 100% discount
				// 						currency: service.currency,
				// 						warehouseCode: service.warehouseCode,
				// 						correctionInvoiceItem: 'ciis_Was',
				// 						u_uslugaID: Number(
				// 							service.u_uslugaID ||
				// 								originalLine.lineNum,
				// 						),
				// 						u_Produkt:
				// 							service.u_Produkt ||
				// 							originalLine.itemDescription,
				// 						u_Kvmetr: '',
				// 						u_Timer: service.u_Timer || null,
				// 						u_Width: originalLine.u_Width,
				// 						u_Height: originalLine.u_Height,
				// 						u_PlannedQuantity:
				// 							service.u_PlannedQuantity,
				// 						u_Coefficient:
				// 							service.u_Coefficient || '1',
				// 						u_Number: service.u_Number || '',
				// 						u_ItemGroup:
				// 							service.u_Modal === 'ort'
				// 								? 'Service'
				// 								: 'Service',
				// 						u_FigureQuantity: Number(
				// 							service.u_FigureQuantity || 0,
				// 						),
				// 						u_ShapeSides:
				// 							service.u_ShapeSides || '',
				// 						u_SizeType: service.u_SizeType || '',
				// 						u_SharepeningType:
				// 							service.u_SharepeningType || '',
				// 						u_ConnectedShape:
				// 							service.u_ConnectedShape || '',
				// 						u_Modal: service.u_Modal || '',
				// 						discountPercent:
				// 							service.u_Modal === 'ort' ? 100 : 0,
				// 					}))

				// 					return [mainLine, ...serviceLines]
				// 				},
				// 			)
				// 		: []),
				// ],

				documentLines: [
					...(Array.isArray(tableData)
						? tableData.map((row) => ({
								lineNum: getNextLineNum(), // Increment line number
								baseEntry: baseEntry,
								baseLine: row.lineNum,
								itemCode: row.itemCode,
								quantity: Number(
									row.quantity *
										calculateKvm(row.width, row.height),
								),
								unitPrice: Number(row.price),
								currency: row.currency,
								warehouseCode: whs,
								u_uslugaID: Number(row.lineNum),
								u_Produkt: null,
								u_Kvmetr: calculateKvm(row.width, row.height),
								u_Width: row.width,
								u_Height: row.height,
								u_Coefficient: row.koefitsent,
								u_Timer: null,
								u_PlannedQuantity: row.quantity,
								u_Number: row.u_Number || '',
								u_ItemGroup: 'Item',
								u_FigureQuantity: 0,
								u_ShapeSides: '',
								u_SizeType: '',
								u_SharepeningType: '',
								u_ConnectedShape: '',
								u_Modal: '',
								discountPercent: 0,
								correctionInvoiceItem: 'ciis_ShouldBe',
							}))
						: []),
					...(Array.isArray(salesOrderData?.documentLines)
						? salesOrderData.documentLines
								?.filter((item) => {
									return item.u_Modal === 'Xarajatlar'
								})
								?.map((originalLine) => {
									// Main item line (the product itself)
									const mainLine = {
										lineNum: getNextLineNum(),
										itemCode: originalLine.itemCode,
										quantity: Number(originalLine.quantity),
										unitPrice:
											originalLine.itemCode ===
											elektrTotal.itemCode
												? +elektrTotal.total
												: originalLine.itemCode ===
													  stanokTotal.itemCode
													? +stanokTotal.total
													: Number(
															originalLine.price,
														),
										currency: originalLine.currency,
										warehouseCode:
											originalLine.warehouseCode,
										correctionInvoiceItem: 'ciis_ShouldBe',
										itemDescription:
											originalLine.itemDescription,
										u_uslugaID:
											Number(originalLine.u_uslugaID) ||
											0,
										u_Produkt: originalLine.u_Produkt,
										u_Kvmetr:
											originalLine.u_Kvmetr ||
											calculateKvm(
												originalLine.u_Width,
												originalLine.u_Height,
											),
										u_Width: originalLine.u_Width,
										u_Height: originalLine.u_Height,
										u_Coefficient:
											originalLine.u_Coefficient,
										u_PlannedQuantity:
											originalLine.u_PlannedQuantity,
										u_Number: originalLine.u_Number || '',
										u_ItemGroup:
											originalLine.u_ItemGroup ||
											'Expenses',
										u_FigureQuantity: Number(
											originalLine.u_FigureQuantity || 0,
										),
										u_ShapeSides:
											originalLine.u_ShapeSides || '',
										u_SizeType:
											originalLine.u_SizeType || '',
										u_SharepeningType:
											originalLine.u_SharepeningType ||
											'',
										u_ConnectedShape:
											originalLine.u_ConnectedShape || '',
										u_Modal: originalLine.u_Modal || '',
										discountPercent: 100,
										baseEntry: baseEntry,
										baseLine: originalLine.lineNum,
									}

									return mainLine
								})
						: []),
					...(Array.isArray(tableData)
						? tableData
								.filter((row) =>
									Array.isArray(row.selectedServices),
								)
								.flatMap((row, rowIndex) =>
									row.selectedServices.map((service) => ({
										lineNum: getNextLineNum(), // Increment line number
										baseEntry: baseEntry,
										baseLine: service.lineNum,
										itemCode: service.itemCode,
										quantity:
											service.u_Modal == 'ort'
												? service?.u_PlannedQuantity
												: service.isChizma ||
													  service.isShablonParametr
													? 1
													: service.u_Modal ===
																'Templete_Services' ||
														  service.u_Modal ===
																'Telefon'
														? service.u_PlannedQuantity *
															service.u_FigureQuantity
														: service.ugpName ===
																	'шт' &&
															  !service.isParametr
															? service.u_FigureQuantity *
																service.itemQuantity
															: service.ugpName ===
																		'шт' &&
																  service.isParametr
																? +service.u_FigureQuantity *
																	service.itemQuantity
																: service.ugpName ===
																			'м' &&
																	  !service.isParametr &&
																	  service.u_Modal !==
																			'Circle_Services'
																	? perimeterQuantity(
																			row.width,
																			row.height,
																			service.itemQuantity,
																		)
																	: service.ugpName ===
																				'м' &&
																		  service.u_Modal ===
																				'Circle_Services'
																		? circleServiceQuantity(
																				row.width,
																				+service.itemQuantity,
																			)
																		: service.ugpName ===
																					'м' &&
																			  service.isParametr
																			? +service.quantity *
																				+service.u_FigureQuantity *
																				service.itemQuantity
																			: Number(
																					+service.u_PlannedQuantity *
																						calculateKvm(
																							row.width,
																							row.height,
																						),
																				),
										unitPrice:
											service.isChizma ||
											service.isShablonParametr
												? 0
												: Number(service.price),
										currency: service.currency,
										warehouseCode: whs,
										u_uslugaID: Number(row.lineNum),
										u_Produkt: row.itemName,
										u_Kvmetr: '',
										u_Timer: service.u_Timer,
										u_Width: row.width,
										u_Height: row.height,
										correctionInvoiceItem: 'ciis_ShouldBe',
										u_PlannedQuantity:
											service.isChizma ||
											service?.u_Modal ===
												'Key_Figures' ||
											service?.u_Modal ===
												'Templete_Figures' ||
											service?.u_Modal === 'Telefon'
												? service.itemQuantity
												: service.ugpName === 'м' &&
													  service.isParametr
													? service.u_FigureQuantity
													: service.u_PlannedQuantity,

										u_Coefficient:
											service.ugpName === 'шт' ||
											service.ugpName === 'м'
												? 1
												: row.koefitsent,
										u_Number: service.u_Number || '',
										u_ItemGroup: service.isChizma
											? 'Chizma'
											: service.isShablonParametr
												? 'ShablonShape'
												: service.isShablonService
													? 'ShablonService'
													: service.isParametr
														? 'Shape'
														: 'Service',
										u_ShapeSides:
											service.u_ItemGroup == 'Shape' ||
											service.u_Modal == 'Rhombic_Figures'
												? service?.u_ShapeSides
												: '',
										u_FigureQuantity:
											service.isParametr ||
											service.u_Modal ==
												'Rhombic_Figures' ||
											service.u_Modal == 'Telefon' ||
											service.u_Modal ===
												'Templete_Services' ||
											(service.u_Modal ===
												'Key_Services' &&
												service.ugpName === 'шт') ||
											(service.u_Modal ===
												'Circle_Services' &&
												service.ugpName === 'шт')
												? service.u_FigureQuantity
												: 0,
										u_SizeType: service.u_SizeType || '',
										u_SharepeningType:
											service.u_SharepeningType || '',
										u_ConnectedShape:
											service.isShablonService
												? row.selectedServices?.find(
														(s) =>
															s.isShablonParametr,
													).itemCode
												: '',
										discountPercent:
											service?.u_Modal == 'ort' ? 100 : 0,
										u_Modal: service.u_Modal || '',
									})),
								)
						: []),
					...(Array.isArray(salesOrderData?.documentLines)
						? salesOrderData.documentLines.flatMap(
								(originalLine) => {
									// Main item line (the product itself)
									const mainLine = {
										lineNum: getNextLineNum(),
										itemCode: originalLine.itemCode,
										quantity: Number(originalLine.quantity),
										unitPrice: Number(originalLine.price),
										currency: originalLine.currency,
										warehouseCode:
											originalLine.warehouseCode,
										correctionInvoiceItem: 'ciis_Was', // This marks it as the old line
										itemDescription:
											originalLine.itemDescription,
										// Copy all other needed fields
										u_uslugaID:
											Number(originalLine.u_uslugaID) ||
											0,
										u_Produkt: originalLine.u_Produkt,
										u_Kvmetr:
											originalLine.u_Kvmetr ||
											calculateKvm(
												originalLine.u_Width,
												originalLine.u_Height,
											),
										u_Width: originalLine.u_Width,
										u_Height: originalLine.u_Height,
										u_Coefficient:
											originalLine.u_Coefficient,
										u_PlannedQuantity:
											originalLine.u_PlannedQuantity,
										u_Number: originalLine.u_Number || '',
										u_ItemGroup:
											originalLine.u_ItemGroup || 'Item',
										u_FigureQuantity: Number(
											originalLine.u_FigureQuantity || 0,
										),
										u_ShapeSides:
											originalLine.u_ShapeSides || '',
										u_SizeType:
											originalLine.u_SizeType || '',
										u_SharepeningType:
											originalLine.u_SharepeningType ||
											'',
										u_ConnectedShape:
											originalLine.u_ConnectedShape || '',
										u_Modal: originalLine.u_Modal || '',
										discountPercent:
											originalLine.u_Modal ===
												'Xarajatlar' ||
											originalLine.u_Modal === 'ort'
												? 100
												: 0,
										baseEntry: baseEntry,
										baseLine: originalLine.lineNum,
									}

									// Service lines attached to this item (like REZKA, delivery, etc.)
									const serviceLines = (
										originalLine.services || []
									).map((service) => ({
										baseEntry: baseEntry,
										baseLine: service.lineNum,
										lineNum: getNextLineNum(),
										itemCode: service.itemCode,
										quantity: Number(service.quantity),
										unitPrice: Number(service.price), // Ortish usually has 100% discount
										currency: service.currency,
										warehouseCode: service.warehouseCode,
										correctionInvoiceItem: 'ciis_Was',
										u_uslugaID: Number(
											service.u_uslugaID ||
												originalLine.lineNum,
										),
										u_Produkt:
											service.u_Produkt ||
											originalLine.itemDescription,
										u_Kvmetr: '',
										u_Timer: service.u_Timer || null,
										u_Width: originalLine.u_Width,
										u_Height: originalLine.u_Height,
										u_PlannedQuantity:
											service.u_PlannedQuantity,
										u_Coefficient:
											service.u_Coefficient || '1',
										u_Number: service.u_Number || '',
										u_ItemGroup:
											service.u_Modal === 'ort'
												? 'Service'
												: 'Service',
										u_FigureQuantity: Number(
											service.u_FigureQuantity || 0,
										),
										u_ShapeSides:
											service.u_ShapeSides || '',
										u_SizeType: service.u_SizeType || '',
										u_SharepeningType:
											service.u_SharepeningType || '',
										u_ConnectedShape:
											service.u_ConnectedShape || '',
										u_Modal: service.u_Modal || '',
										discountPercent:
											service.u_Modal === 'ort' ? 100 : 0,
									}))

									return [mainLine, ...serviceLines]
								},
							)
						: []),
				],
			}

			await http.patch(`api/sales/sotuv-buyurtmasi/${docEntry}`, data)
			successRef.current.open(t('sucEdited'))
		} catch (error) {
			catchError(error, errorRef)
		} finally {
			setIsBtnLoading(false)
		}
	}

	const addRow = () => {
		setTableData([
			...tableData,
			{
				key: Date.now(),
				lineNum: biggestLineNum + 1,
				itemCode: null,
				itemName: null,
				width: '',
				height: '',
				quantity: '',
				ugpName: '',
				price: '',
				lineTotal: '',
				u_Timer: null,
				u_Number: null,
				koefitsent: 1,
				disabled: false,
				selectedServices: [],
				itemType: 'Item',
			},
		])
	}

	const copyRow = (record) => {
		setTableData([
			...tableData,
			{
				key: Date.now(),
				lineNum: biggestLineNum + 1,
				itemCode: record.itemCode,
				itemName: record.itemName,
				width: '',
				height: '',
				quantity: '',
				ugpName: '',
				currency: currency,
				price: record.price,
				lineTotal: '',
				u_Timer: record.u_Timer,
				u_Number: record.u_Number,
				koefitsent: record.koefitsent,
				disabled: record.disabled,
				selectedServices: [],
				itemType: record.itemType,
			},
		])
	}

	const removeRow = (key) => {
		if (tableData.length > 1) {
			setTableData(tableData.filter((row) => row.key !== key))
		}
	}

	const uploadImg = async (index) => {
		const image = imageList[index]

		if (!image.file) {
			message.error('Фотография не выбрано')
			return
		}

		const formData = new FormData()
		formData.append('file', image.file)

		const generateRandomKey = () => {
			const characters =
				'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
			let randomKey = ''
			for (let i = 0; i < 16; i++) {
				randomKey += characters.charAt(
					Math.floor(Math.random() * characters.length),
				)
			}
			return randomKey
		}

		const randomKey = generateRandomKey()
		const title = 'YourTitle'

		formData.append('Title', title)
		formData.append('Key', randomKey)

		try {
			const updatedImageList = [...imageList]
			updatedImageList[index].imgLoading = true
			setImageList(updatedImageList)

			const res = await http.post('api/assets/upload', formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			})

			const { key } = res.data
			updatedImageList[index].path = key
			setImageList(updatedImageList)

			message.success('Успешно загружено!')
		} catch (err) {
			message.error('Ошибка загрузки')
		} finally {
			const updatedImageList = [...imageList]
			updatedImageList[index].imgLoading = false
			setImageList(updatedImageList)
		}
	}

	const viewImage = async (index) => {
		const image = imageList[index]

		try {
			const res = await http.get(`api/assets/download/${image.path}`, {
				responseType: 'blob',
			})

			const url = window.URL.createObjectURL(
				new Blob([res.data], {
					type: 'image/png',
				}),
			)

			const link = document.createElement('a')
			link.href = url
			link.setAttribute('download', 'BP.png')
			document.body.appendChild(link)
			link.click()

			document.body.removeChild(link)
			window.URL.revokeObjectURL(url)
		} catch (error) {
			message.error('Ошибка загрузки файла')
		}
	}

	const addNewRow = () => {
		setImageList([
			...imageList,
			{ file: null, path: '', imgLoading: false },
		])
	}

	const deleteRow = (index) => {
		setImageList(imageList.filter((_, i) => i !== index))
	}

	const handleDateChange = (e) => {
		const input = Number(e.target.value)
		setInputDateCount(input)

		if (!isNaN(input)) {
			let daysToAdd = input
			const newDate = moment(salesOrderData?.docDueDate || moment())

			while (daysToAdd > 0) {
				newDate.add(1, 'days')
				if (newDate.day() !== 0) {
					daysToAdd--
				}
			}

			setDate(newDate.format('YYYY-MM-DD'))
		} else {
			console.error('Invalid input: Please input a valid number.')
		}
	}
	const handleFileChange = (event, index) => {
		const updatedImageList = [...imageList]
		updatedImageList[index].file = event.target.files[0]
		setImageList(updatedImageList)
	}

	const handleCardNameChange = (val) => {
		debouncedSet(val, setSearchClientName)
	}

	const handleItemNameChange = (val) => {
		debouncedSet(val, setSearchItemName)
	}

	const handleKoefitsentChange = (value, itemName) => {
		setTableData((prevData) => {
			const koef = parseFloat(value) || 0
			return prevData.map((row) => {
				if (row.itemName === itemName) {
					// Update all grouped rows
					console.log('row', row)
					const selectedPrices = row?.selectedServices.reduce(
						(acc, service) =>
							service.ugpName !== 'шт'
								? acc + service.price
								: acc,
						0,
					)

					const shtPrices = calculateShtPrices(row.selectedServices)

					const totalWithKoef = calculateTotalWithKoef(
						row.width,
						row.height,
						row.quantity,
						koef,
					)

					// const lineTotal =
					// 	calculateLineTotal(
					// 		row.price,
					// 		selectedPrices,
					// 		totalWithKoef,
					// 	) + shtPrices

					const lineTotal = calculateLineTotal(
						row.price,
						0, //Endi Uslugalarni Narxini koefitsent bn hisoblanmidi
						totalWithKoef,
					)

					return {
						...row,
						koefitsent: koef, // Store updated coefficient
						lineTotalWithKoef: totalWithKoef, // Recalculate total
						lineTotal, // Update calculated total
					}
				}
				return row
			})
		})
	}

	const handleModalYes = () => {
		setIsConfirmModalVisible(false)
		navigate('/sales-order')
	}

	const handleModalNo = () => {
		setIsConfirmModalVisible(false)
	}

	const handleModalCancel = () => {
		setIsConfirmModalVisible(false)
	}

	const handleInputChange = (rowKey, index, value) => {
		setInputValues((prev) => {
			const updatedValues = { ...prev }
			if (!updatedValues[rowKey]) {
				updatedValues[rowKey] = [] // Initialize row if not present
			}
			updatedValues[rowKey][index] = value // Set the specific input value
			return updatedValues
		})
	}
	const summarizeTableData = (data) => {
		const groupedData = data.reduce((acc, record) => {
			const {
				itemName,
				width,
				height,
				quantity,
				koefitsent,
				amountInWhs,
				price,
			} = record
			const koef = koefitsent || 1
			const totalWithKoef = calculateTotalWithKoef(
				width,
				height,
				quantity,
				koef,
			)

			if (!acc[itemName]) {
				acc[itemName] = {
					...record,
					lineTotalWithKoef: 0,
					lineTotal: 0,
					count: 0,
					amountInWhs,
					koefitsent,
				}
			}

			acc[itemName].lineTotalWithKoef += totalWithKoef
			acc[itemName].count += 1

			return acc
		}, {})

		return Object.values(groupedData).map((item, index) => ({
			...item,
			key: index,
		}))
	}

	const summarizedData = summarizeTableData(tableData)

	const totalPerimetrToM = tableData.reduce(
		(acc, curr) => {
			acc.height += curr.height / 1000
			acc.width += curr.width / 1000
			acc.quantity += curr.quantity
			return acc
		},
		{ height: 0, width: 0, quantity: 0 },
	)

	return (
		<Layout>
			<div className={'p-7'}>
				<div className="flex items-center gap-10 flex-wrap">
					<div className={'flex items-end'}>
						<div className="flex flex-col items-start gap-3 ">
							<p className="font-nunito">{t('Client')}</p>
							<AutoComplete
								loading={loadingClient}
								showSearch
								value={clientName}
								className=" w-[300px]"
								onSelect={(value) => {
									const val = value.split(' ,/ ')[0]

									setClientName(val)
									handleCardNameChange(val)
									const selectedOption = clientsData.find(
										(client) => {
											const cardName = get(
												client,
												'cardName',
												'',
											)
											const cardCode = get(
												client,
												'cardCode',
												'',
											)
											const phoneNumber = get(
												client,
												'Cellular',
												'',
											)
												? get(client, 'Cellular', '')
												: ''
											const formattedValue = [
												cardName,
												phoneNumber,
											]
												.filter(Boolean)
												.join(' ')
											return (
												`${formattedValue} ,/ ${cardCode}` ===
												value
											)
										},
									)

									if (selectedOption) {
										const cardCode = get(
											selectedOption,
											'cardCode',
											'',
										)
										setClientCode(cardCode)
									}
								}}
								disabled={isDisabled}
								onChange={(val) => {
									const value = val.split(' ,/ ')[0]
									setClientName(value)
									handleCardNameChange(value)
								}}
								options={clientsData.map((client) => ({
									value: `${client.cardName}${client.Cellular ? ` ${client.Cellular}` : ''} ,/ ${client.cardCode}`,
									label: (
										<div className="flex items-center justify-between">
											<p>{client.cardName}</p>
											{client.Cellular && (
												<Tag
													color="blue"
													className="text-[9px]"
												>
													{client.Cellular}
												</Tag>
											)}
										</div>
									),
								}))}
							/>
						</div>
						{/* <button
							className="w-[30px] h-8 bg-blue-700 text-white text-lg hover:bg-blue-500 disabled:opacity-50"
							onClick={() => setIsModalVisible(true)}
							disabled
						>
							+
						</button> */}
					</div>
					<div className="flex flex-col gap-2">
						<p>{t('currency')}</p>
						<div className="flex">
							<Select
								value={currency}
								onChange={(value) => setCurrency(value)}
								className="w-[150px]"
								disabled={isDisabled}
							>
								<Select.Option key={1} value={'UZS'}>
									UZS
								</Select.Option>
								<Select.Option key={1} value={'USD'}>
									USD
								</Select.Option>
							</Select>
						</div>
					</div>
					{roleNames.includes('admin') && (
						<div className="flex flex-col gap-2">
							<p>{t('departmentName')}</p>
							<div className="flex">
								<Select
									value={departmentAdmin}
									className="flex h-8  w-[150px] items-center justify-center "
									style={{ color: 'black' }}
									onChange={(val) => {
										setDepartmentAdmin(val)
									}}
									disabled={isDisabled}
									loading={departmentLoading}
									options={departmentData.map(
										(department) => {
											return {
												label: department.name,
												value: department.code,
											}
										},
									)}
									filterOption={(input, option) =>
										option.label
											.toLowerCase()
											.includes(input.toLowerCase())
									}
									showSearch
								/>
							</div>
						</div>
					)}
					{roleNames.includes('admin') && (
						<div className="flex flex-col gap-2">
							<p>{t('slpName')}</p>
							<Select
								value={slpAdmin}
								className="flex h-8  w-[150px] items-center justify-center "
								style={{ color: 'black' }}
								onChange={(val) => {
									setSlpAdmin(val)
								}}
								disabled={isDisabled}
								loading={slpLoading}
								options={slpData.map((slp) => {
									return {
										label: slp.slpName,
										value: Number(slp.slpCode),
									}
								})}
								filterOption={(input, option) =>
									option.label
										.toLowerCase()
										.includes(input.toLowerCase())
								}
								showSearch
							/>
						</div>
					)}
					{roleNames.includes('admin') && (
						<div className="flex flex-col gap-2">
							<p>{t('date')}</p>
							<Input
								// type="date"
								value={moment(dateSale).format('YYYY-MM-DD')}
								onChange={(e) => setDateSale(e.target.value)}
								className="w-full"
								disabled={isDisabled}
								filterOption={(input, option) =>
									option.label
										.toLowerCase()
										.includes(input.toLowerCase())
								}
								showSearch
							/>
						</div>
					)}
					{roleNames.includes('admin') && (
						<div className="flex flex-col gap-2">
							<p>{t('whs')}</p>
							{/* <Spin spinning={whsLoading}> */}
							<Select
								value={whs}
								onChange={(value) => setWhs(value)}
								className="w-[200px] "
								loading={whsLoading}
								options={warehouseData.map((warehouse) => ({
									label: warehouse.name,
									value: warehouse.code,
								}))}
								disabled={isDisabled}
								filterOption={(input, option) =>
									option.label
										.toLowerCase()
										.includes(input.toLowerCase())
								}
								showSearch
							/>
							{/* </Spin> */}
						</div>
					)}
				</div>

				<div className="flex items-end gap-2 mt-5 ">
					<div className="flex flex-col gap-2">
						<p>{t('bpDebt')}</p>
						<Input
							value={
								clientCode
									? `${numberWithSpacesIntl(bpDebt) || 0} USD`
									: ''
							}
							className="w-[200px] "
							disabled
						/>
					</div>
					<Button
						type="primary"
						onClick={() => setIsViewBpBalanceModalVisible(true)}
						disabled={!clientCode}
						className="bg-blue-700 text-white rounded-lg  hover:bg-blue-500 disabled:bg-blue-300"
					>
						<ViewIcon />
					</Button>
				</div>

				<Table
					columns={columns}
					dataSource={tableData}
					pagination={false}
					className="border-1 mt-12 border-black  my-custom-table"
					bordered
					scroll={{ x: 'max-content' }}
				/>

				<Table
					columns={columnsKoefitsent}
					dataSource={summarizedData}
					pagination={false}
					className="border-1 mt-2 border-black"
					bordered
					scroll={{ x: 'max-content' }}
				/>

				<div className="flex gap-10 mt-20 drop-shadow-lg bg-white p-5 rounded-lg">
					<div className="w-full flex flex-col  gap-6 ">
						<div className="flex gap-5 items-center w-full">
							<div className="flex flex-col items-start gap-3 w-full">
								<p className="font-nunito">{t('deadLine')}</p>
								<Input
									type="number"
									min={0}
									disabled={isDisabled}
									className="w-full h-10"
									onWheel={(e) => e.target.blur()}
									onChange={handleDateChange}
									value={inputDateCount}
								/>
							</div>
							<div className="flex flex-col items-start gap-3 w-full">
								<p className="font-nunito">
									{t('otgruzkaServicesTotal')}
								</p>
								<Input
									type="text"
									value={formatNumberWithSpaces(
										otgruzkaServicesTotal,
									)}
									className="h-10 w-full "
									style={{ color: 'black' }}
									suffix={` ${currency}`}
									disabled
								/>
							</div>
						</div>
						<div className="flex   gap-5 items-end">
							<div className="flex flex-col items-start gap-3">
								<p className="font-nunito">{t('minTotal')}</p>
								<Input
									type="text"
									value={`${numberWithSpacesIntl(docTotal || 0)} ${currency}`}
									className="h-10 w-full "
									style={{ color: 'black' }}
									disabled
								/>
							</div>
							<div className="flex flex-col items-start gap-3">
								<p className="font-nunito">{t('totalKvm')}</p>
								<Input
									type="text"
									value={totalKvm}
									className="h-10 w-full "
									style={{ color: 'black' }}
									disabled
								/>
							</div>

							<div className="flex flex-col items-start gap-3">
								<p className="font-nunito">
									{t('totalPerimeter')} ({t('m')})
								</p>
								<Input
									type="text"
									value={formatNumberWithSpaces(
										(totalPerimetrToM.height +
											totalPerimetrToM.width) *
											2 *
											totalPerimetrToM.quantity,
									)}
									className="h-10 w-full "
									style={{ color: 'black' }}
									disabled
								/>
							</div>
						</div>

						<div className="flex flex-col items-start gap-3 w-full">
							<p className="font-nunito">{t('docTotal')}</p>
							<Input
								value={formatNumberWithSpaces(inputDocTotal)}
								className={'w-full h-10'}
								min={docTotal || 0}
								suffix={
									<span className="text-gray-400">UZS</span>
								}
								onBlur={handleDocTotalBlur}
								onChange={handleDocTotalChange}
							/>
							{isDiscountBigger && (
								<p className="text-red-600 font-nunito">
									{t('docTotalBigger')}{' '}
									{numberWithSpacesIntl(docTotal) || 0}
								</p>
							)}
						</div>

						{/* <div className="flex flex-col items-start gap-3 ">
							<p className="font-nunito">{t('Discount')}</p>
							<Input
								// type={'number'}
								controls={false}
								value={
									docTotalWithDiscount,
								}
								className={'w-full'}
								min={0}
								onChange={(e) => {
									const val = e.target.value
									if (
										val <=
										(docTotal / 100) *
											get(getMe, 'u_Discount', 1)
									) {
										setDocTotalWithDiscount(val)
										setIsDiscountBigger(false)
									} else {
										setIsDiscountBigger(true)
									}
								}}
							/>
							{isDiscountBigger && (
								<p className="text-red-600 font-nunito">
									{t('discountBigger')}{' '}
									{(docTotal / 100) *
										get(getMe, 'u_Discount', 1) || 0}
								</p>
							)}
						</div> */}
						{/* <div className="flex flex-col items-start gap-3 w-full">
							<p className="font-nunito">{t('sendFile')}</p>
							<Input
								type="checkbox"
								value={sendFile}
								onChange={(e) => {
									setSendFile(e.target.checked)
								}}
								className="w-fit"
							/>
						</div> */}
					</div>

					<div className="w-full flex  h-full">
						<div className="flex flex-col items-start gap-3 w-full">
							<p className="font-nunito">{t('comments')} </p>
							<TextArea
								className={'w-full'}
								rows={11}
								onChange={(e) => {
									setComments(e.target.value)
								}}
								value={comments}
							/>
						</div>
					</div>
				</div>
				{/* <div>
					{imageList.map((image, index) => (
						<div
							key={index}
							className="flex w-full items-start gap-1 flex-col mt-5 mb-10"
						>
							<div>
								<p className="font-bold">
									{t('photo')}-{index + 1}
								</p>
							</div>
							<div className="flex items-center gap-3">
								<Input
									type="file"
									onChange={(e) => handleFileChange(e, index)}
									className="w-full"
								/>

								<Button
									onClick={() => uploadImg(index)}
									isLoading={image.imgLoading}
									className="h-9 w-[200px] rounded-3xl bg-[#0A4D68] text-white"
								>
									{t('upload')}
								</Button>
								{image.path && (
									<Button
										onClick={() => viewImage(index)}
										className="h-9 w-[200px] rounded-3xl bg-[#0A4D68] text-white"
									>
										{t('download')}
									</Button>
								)}
								{index !== 0 && (
									<Button
										onClick={() => deleteRow(index)}
										className="h-9 w-[70px] rounded-3xl  bg-red-500 text-white"
									></Button>
								)}

								{index === imageList.length - 1 && (
									<Button
										onClick={addNewRow}
										className="h-9 w-[70px] rounded-3xl bg-[#0A4D68] text-white"
									></Button>
								)}
							</div>
						</div>
					))}
				</div> */}

				<div className={'flex mt-10 w-full items-center gap-10'}>
					<Button
						onClick={() => setIsConfirmModalVisible(true)}
						type={'danger'}
						className="w-full bg-red-600 text-white"
					>
						{t('back')}
					</Button>
					<Button
						onClick={onSubmit}
						loading={btnLoading}
						disabled={
							btnLoading ||
							(imageList.every((image) => image.file) &&
								!imageList.every((image) => image.path))
							// !tableData.length === 0 ||
							// !clientCode ||
							// !departmentAdmin ||
							// !slpCode ||
							// !dateSale ||
							// !whs
						}
						type={'primary'}
						className="w-full"
					>
						{t('create')}
					</Button>
				</div>
			</div>

			{/* <Modal
				title={
					<div className="flex items-center gap-2">
						<span className="cursor-pointer text-2xl font-bold">
							{t('services')}
						</span>
					</div>
				}
				open={isModalOpen}
				onCancel={() => {
					setIsConfirmServiceModalVisible(true)
				}}
				// onOk={handleOkServices}
				footer={null}
				width="55%"
			>
				<div className="w-full">
					<Space style={{ marginBottom: 16 }} className="mt-5">
						<button
							className={`${
								activeTab === 'tab1'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold `}
							onClick={() => setActiveTab('tab1')}
						>
							{t('Xizmatlar')}
						</button>
						<button
							className={`${
								activeTab === 'tab2'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3 `}
							onClick={() => setActiveTab('tab2')}
						>
							{t('Dumaloq xizmati')}
						</button>

						<button
							className={`${
								activeTab === 'tab3'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3`}
							onClick={() => setActiveTab('tab3')}
						>
							{t('shapes')}
						</button>
						<button
							className={`${
								activeTab === 'tab4'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3`}
							onClick={() => setActiveTab('tab4')}
						>
							{t('chizmalar')}
						</button>
					</Space>
					<div className="mt-5">{renderContent()}</div>
					<div className="mt-5 flex items-center justify-end  gap-2">
						<Button
							type="danger"
							className="bg-red-600 text-white hover:bg-red-500"
							onClick={() => {
								setIsConfirmServiceModalVisible(true)
							}}
						>
							{t('cancel')}
						</Button>
						<Button
							type="danger"
							className="bg-blue-800 text-white hover:bg-blue-600"
							onClick={handleOkCombined}
						>
							{t('save')}
						</Button>
					</div>
				</div>
			</Modal> */}

			<CreteCustomerModal
				visible={isModalVisible}
				data={null}
				onClose={() => {
					refetch()
					setIsModalVisible(false)
				}}
				onConfirm={(code) => {
					const data = `${code?.name} ${code?.phoneNumber ? code?.phoneNumber : ''}`
					setClientName(data)
					setClientCode(code?.cardCode)
				}}
			/>
			<ViewDepartmentsBalanceModal
				visible={isViewBpBalanceModalVisible}
				data={bpBalanceData[0]}
				onClose={() => {
					setIsViewBpBalanceModalVisible(false)
				}}
			/>

			<ConfirmExitModal
				visible={isConfirmModalVisible}
				handleClickCancel={handleModalCancel}
				handleClickNo={handleModalNo}
				handleClickYes={handleModalYes}
			/>
			<SuccessModal
				getRef={(r) => {
					successRef.current = r
				}}
				onConfirm={() => {
					navigate('/sales-order')
				}}
			/>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
			<WarningModal
				getRef={(r) => {
					warningRef.current = r
				}}
			/>
			{/* <ConfirmExitModal
				visible={isConfirmServiceModalVisible}
				handleClickCancel={handleServiceModalCancel}
				handleClickNo={handleServiceModalNo}
				handleClickYes={handleServiceModalYes}
			/> */}
			<ServicesModal
				visible={isModalOpen}
				onClose={() => setIsModalOpen(false)}
				selectedData={selectedServices}
				tableData={tableData}
				setTableData={setTableData}
				selectedRowIndex={selectedRowIndex}
			/>
		</Layout>
	)
}

export default EditSalesOrder
